module.exports = __webpack_public_path__ + "static/media/Pharmacy.e0ac7988.png";